/* eslint-disable no-restricted-exports */
export { default } from './analytics';
export { default as PageAnalytics } from './page-analytics';
